import { Ticket } from "../../types/entities/ticket"

export function formatSessionDateTime(raw: string): { date: string; time: string; full: string } {
    try {
        const d = new Date(raw)
        if (isNaN(d.getTime())) return { date: raw, time: "", full: raw }
        const date = d.toLocaleDateString("ru-RU", {
            weekday: "short",
            day: "numeric",
            month: "long",
        })
        const time = d.toLocaleTimeString("ru-RU", { hour: "2-digit", minute: "2-digit" })
        return { date, time, full: `${date}, ${time}` }
    } catch {
        return { date: raw, time: "", full: raw }
    }
}

export function getTicketStatusColor(statusId: number, statusName: string): string {
    if (statusId === 3 || statusName.toLowerCase().includes("оплач")) return "#29cc6a"
    if (statusId === 2 || statusName.toLowerCase().includes("не оплачен")) return "#f5a623"
    if (statusName.toLowerCase().includes("отмен")) return "#e4206b"
    return "#349be6"
}

export function formatStatusLabel(name: string): string {
    return name.replace(/\.$/, "").trim()
}

export function fmtRub(n: number) {
    return n.toLocaleString("ru-RU", { maximumFractionDigits: 0 })
}

/** 1414690109 → 1 414 690 109 (группы по 3 справа) */
export function formatOrderNumber(value: string | number | null | undefined): string {
    if (value == null || value === "") return ""
    const raw = String(value).trim()
    const digits = raw.replace(/\D/g, "")
    if (!digits || digits.length !== raw.length) return raw

    const groups: string[] = []
    for (let i = digits.length; i > 0; i -= 3) {
        groups.unshift(digits.slice(Math.max(0, i - 3), i))
    }
    return groups.join(" ")
}

export function isUnpaid(ticket: Ticket) {
    return ticket.status.id === 2
}

export function isPaid(ticket: Ticket) {
    return ticket.status.id === 3
}

export function formatSeats(seats: Ticket["seats"]) {
    return seats.map(s => `ряд ${s.row}, место ${s.place}`).join(" · ")
}
